module.exports = __webpack_public_path__ + "static/media/usa-msb.62af0ba7.png";